<template>
  <div class="widget-form-container">
    <el-form
      :size="data.config.size"
      :label-position="data.config.labelPosition"
      :class="{
        customClass,
        swLabelCenter: data.config.labelPosition === 'center',
      }"
      :label-width="data.config.labelWidth + 'px'"
    >
      <draggable
        class
        v-model="data.list"
        v-bind="{
          group: 'people',
          ghostClass: 'ghost',
          animation: 200,
          handle: '.drag-widget',
        }"
        @end="handleMoveEnd"
        @add="handleWidgetAdd"
      >
        <transition-group name="fade" tag="div" class="widget-form-list">
          <template v-for="(element, index) in data.list">
            <template v-if="element.key">
              <advanced-form-item
                v-if="
                  Object.keys(advancedComponents).indexOf(element.type) >= 0
                "
                :key="element.key + index"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></advanced-form-item>
              <son-form
                v-else-if="element.type === 'sonform'"
                :key="element.key + index"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></son-form>
              <widget-col-item
                v-else-if="element.type === 'grid'"
                :key="element.key + index"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></widget-col-item>
              <widget-comment-item
                v-else-if="element.type === 'comment'"
                :key="element.key + index"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></widget-comment-item>
              <widget-report
                v-else-if="element.type === 'report'"
                :key="element.key + index"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></widget-report>
              <widget-form-item
                v-else
                :key="element.key"
                :element="element"
                :select.sync="selectWidget"
                :index="index"
                :data="data"
                :data-config="data.config"
                @select-change="handleSelectChange"
              ></widget-form-item>
            </template>
          </template>
        </transition-group>
      </draggable>
    </el-form>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import WidgetFormItem from './WidgetFormItem'
import WidgetColItem from './WidgetColItem'
import WidgetCommentItem from './Comment/widgetIndex'
import WidgetReport from './WidgetReport'
import { advancedComponents } from './advanced/advanced.js'
import AdvancedFormItem from './advanced/AdvancedFormItem'
import SonForm from './advanced/sonfrom/SonForm'
import widgetFormUtils from '../util/widgetFormUtils'
import { generateKeyToTD } from '../util'

export default {
  name: 'widget-form',
  components: {
    Draggable,
    WidgetFormItem,
    WidgetColItem,
    AdvancedFormItem,
    SonForm,
    WidgetCommentItem,
    WidgetReport,
  },
  props: ['data', 'select'],
  data() {
    return {
      advancedComponents,
      selectWidget: this.select,
    }
  },
  mounted() {
    document.body.ondrop = function (event) {
      const isFirefox =
        navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      if (isFirefox) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  },
  methods: {
    handleMoveEnd() {},
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetAdd(evt) {
      const newIndex = evt.newIndex
      const to = evt.to
      this.data.list[newIndex].options.isShowSelect = true
      widgetFormUtils.handleWidgetAdd(newIndex, to, this.data, this, false)
      if (this.data.list[newIndex].type == 'report') {
        this.data.list[newIndex].rows = generateKeyToTD(
          this.data.list[newIndex].rows
        )
      }
      this.selectWidget = this.data.list[newIndex]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length - 1 === index) {
        if (index === 0) {
          this.selectWidget = {}
        } else {
          this.selectWidget = this.data.list[index - 1]
        }
      } else {
        this.selectWidget = this.data.list[index + 1]
      }

      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
    handleSelectChange(index) {
      setTimeout(() => {
        index >= 0
          ? (this.selectWidget = this.data.list[index])
          : (this.selectWidget = {})
      })
    },
  },
  watch: {
    select: {
      handler() {
        if (
          this.select &&
          this.select.type &&
          this.select.type === 'textarea'
        ) {
          const opt = this.select.options
          if (!Object.prototype.hasOwnProperty.call(opt, 'languageList')) {
            this.$set(opt, 'languageList', [
              { value: '同意', key: 1 },
              { value: '不同意', key: 2 },
            ])
            this.$set(opt, 'ApprovalLanguage', [])
          }
          if (!Object.prototype.hasOwnProperty.call(opt, 'defaultRows')) {
            this.$set(opt, 'defaultRows', 5)
          }
        }
        if (
          this.select &&
          this.select.type &&
          this.select.type === 'organization'
        ) {
          const opt = this.select.options
          if (!Object.prototype.hasOwnProperty.call(opt, 'showAllLevels')) {
            this.$set(opt, 'showAllLevels', true)
          }
          if (!Object.prototype.hasOwnProperty.call(opt, 'orgRootId')) {
            this.$set(opt, 'orgRootId', '')
          }
          if (!Object.prototype.hasOwnProperty.call(opt, 'initCurOrgCode')) {
            this.$set(opt, 'initCurOrgCode', '')
          }
        }
        // 此处是人员选择使用组织机构选人时，获取组织机构数据后处理数据时需要以下字段
        if (this.select && this.select.type && this.select.type === 'user') {
          const opt = this.select.options
          if (!Object.prototype.hasOwnProperty.call(opt, 'useOraganization')) {
            this.$set(opt, 'props', {
              value: 'id',
              label: 'ins_name',
              children: 'children',
              pk: 'id',
              ppk: 'pid',
              paramFormat: 'data',
            })
            this.$set(opt, 'useOraganization', false)
            this.$set(opt, 'optionsList', [])
          }
          if (!Object.prototype.hasOwnProperty.call(opt, 'supportMobileInit')) {
            this.$set(opt, 'supportMobileInit', true)
          }
        }
        if (
          this.select &&
          this.select.type &&
          this.select.type === 'select' &&
          this.select.isSon
        ) {
          const opt = this.select.options
          if (!Object.prototype.hasOwnProperty.call(opt, 'excelImportLabel')) {
            this.$set(opt, 'excelImportLabel', false)
          }
        }
        if (this.select && this.select.type && this.select.type === 'file') {
          const opt = this.select.options
          if (!Object.prototype.hasOwnProperty.call(opt, 'downloadType')) {
            this.$set(opt, 'downloadType', 'ordinaryType')
          }
        }

        this.selectWidget = this.select
      },
    },
    selectWidget: {
      handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.$emit('update:select', val)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    customClass() {
      return this.data.config.customClass
    },
  },
}
</script>
<style>
.center-container .el-main {
  background-color: rgb(241, 237, 237);
}

.widget-form-container {
  margin-left: 20px;
  margin-right: 20px;
}

.el-form.customClass {
  padding-bottom: 1px;
}

/* 以上表单设计样式修改 */

.swLabelCenter .el-form-item__label {
  text-align: center;
}
</style>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-form.customClass > textarea {
  display: none !important;
}
</style>
